import { useState } from "react";
import { BigButton } from "../PublicShell";
import { FieldInput } from "./DiaryInputs";
import { isBlank, newId } from "./diaryUtils";

/** Add or edit one diary entry (only the fields for the day itself — next-day questions come later). */
export function EntryForm({ fields, entry, label, onSave, onCancel, testId }) {
  const [draft, setDraft] = useState(entry || { id: newId() });
  const [error, setError] = useState(null);
  function save() {
    const missing = fields.find((f) => f.required && isBlank(typeof draft[f.code] === "string" ? draft[f.code].trim() : draft[f.code]));
    if (missing) { setError(`Please fill in “${missing.prompt}”.`); return; }
    onSave({ ...draft, [fields[0].code]: typeof draft[fields[0].code] === "string" ? draft[fields[0].code].trim() : draft[fields[0].code] });
  }
  return (
    <div className="space-y-5 rounded-2xl border-2 border-zinc-900 bg-white p-4 sm:p-5" data-testid={testId}>
      <h3 className="font-display text-xl font-bold text-zinc-950">{entry ? `Edit ${label}` : `Add an ${label}`}</h3>
      {fields.map((f) => (
        <div key={f.code}>
          <div className="mb-2 text-lg font-semibold text-zinc-900">{f.prompt}</div>
          <FieldInput field={f} value={draft[f.code]} testId={`${testId}-${f.code}`}
                      onChange={(v) => { setError(null); setDraft((d) => ({ ...d, [f.code]: v })); }} />
        </div>
      ))}
      {error && <p className="text-base font-semibold text-red-700" role="alert" data-testid={`${testId}-error`}>{error}</p>}
      <div className="flex flex-wrap gap-3">
        <BigButton onClick={save} data-testid={`${testId}-save`}>{entry ? "Save changes" : `Save ${label}`}</BigButton>
        <BigButton variant="secondary" onClick={onCancel} data-testid={`${testId}-cancel`}>Cancel</BigButton>
      </div>
    </div>
  );
}
